module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/staff/staff-grid/staff-grid.component.css
// module id = ./src/app/technical/staff/staff-grid/staff-grid.component.css
// module chunks = main